module.exports = __webpack_public_path__ + "img/pic_finance.b6e6a899.png";